//import React, { Suspense } from 'react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from 'App';
import { BrowserRouter } from "react-router-dom";
//import { InitialDataContext } from 'InitialDataContext';
import { Hydrate, QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { I18nextProvider } from "react-i18next";
import i18next from "translations/i18n";

//import Loader from 'components/Loader';


//console.log("index.js")

//Default values query-clien all project
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchInterval: 5000,
            //staleTime: 4000,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
            retry: 3,
            retryDelay: 3000,
            refetchIntervalInBackground: true,
            refetchOnWindowFocus: false
            //retry: process.env.NODE_ENV === 'production',
            //refetchOnWindowFocus: process.env.NODE_ENV === 'production',
            // notifyOnChangeProps: 'tracked',
            // onError: (error) =>
            //     console.error(`Something went wrong retriving data: ${error.message}`)
        },
    },
})



const container = document.getElementById("root");
//Suspense https://17.reactjs.org/docs/concurrent-mode-suspense.html
//console.log("Client Side Render has Child");
const root = ReactDOM.createRoot(container);
const dehydratedState = window.__REACT_QUERY_STATE__;
root.render(
    <QueryClientProvider client={queryClient}>
        <I18nextProvider i18n={i18next}>
            <BrowserRouter>
                <Hydrate state={dehydratedState}>
                    <App />
                    <ReactQueryDevtools initialIsOpen={true} />
                </Hydrate>
            </BrowserRouter>
        </I18nextProvider>
    </QueryClientProvider>
);





